import { useQuery } from 'react-query';
import ThematicGroupService from 'services/thematicGroupService';

export function useGetThematicGroups(queryOptions = {}) {
  const queryKey = [ 'thematic-groups' ];
  const queryFn = () => { return ThematicGroupService.get(); };

  const q = useQuery({
    queryKey,
    queryFn,
    ...queryOptions,
  });
  return {
    thematicGroups: q.data,
    thematicGroupsLoading: q.isLoading,
    thematicGroupsError: q.isError,
  };
}
